import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {Select} from "antd";
import {setSpaceId} from "../../redux/slices/selectSpace";
import {useEffect} from "react";
import {FETCH_PRODUCT_LIST} from "../../redux/actions";

const SpaceSelectSearch = ({defaultValue , options}) => {


    const { t } = useTranslation()

    const dispatch = useDispatch();

    const {selectSpace} = useSelector((state) => state.selectSpace);

    const selectedSpace = options?.find((space) => space.id === selectSpace) || defaultValue;



    let switchValue =
        selectSpace ?
            <div style={{display: "flex", alignItems: "center"}}>
                <span>{selectedSpace.name}</span>
            </div>
            :
            <span>{t('search.space')}</span>

    const handleChangeSelect = (id) => {
        dispatch(setSpaceId(id));
    }


    useEffect(() => {
    //    dispatch({ type: FETCH_PRODUCT_LIST });
    }, [selectSpace, dispatch ]);


    return (
        <Select
        style={{width:'100%'}}
            placeholder={t('search.color')}
            defaultValue={defaultValue}
            value={{
                value: selectedSpace.id,
                label: switchValue,
            }}
            onChange={handleChangeSelect}
            options={options?.map((space) => ({
                value: space.id, // Pass ID as value
                label: (
                    <div style={{display: "flex", alignItems: "center"}}>
                        <span>{space.name}</span>
                    </div>
                ),
            }))}
        />
    )
}


export default SpaceSelectSearch
